import { render, staticRenderFns } from "./PopupTutoWelcome.vue?vue&type=template&id=2eea6bb1&scoped=true&"
import script from "./PopupTutoWelcome.vue?vue&type=script&lang=js&"
export * from "./PopupTutoWelcome.vue?vue&type=script&lang=js&"
import style0 from "./PopupTutoWelcome.vue?vue&type=style&index=0&id=2eea6bb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eea6bb1",
  null
  
)

component.options.__file = "PopupTutoWelcome.vue"
export default component.exports